<template>
  <div id="app-index">
    <div class="index-box">
      <div class="logo">
        <img :src="logoUrl" alt />
      </div>
      <div class="content">
        <div class="scroll_box">
          <ul>
            <li
              v-for="(item,index) in peopleData"
              :key="index"
              ref="rollul"
              :class="{anim:animate==true}"
            >
              <div class="p-box">
                <img v-if="item.headimg_url" :src="item.headimg_url" alt />
                <img v-else src="../../assets/images/headPortrait.png" alt />
                <span :title="item.pub_name">{{item.pub_name}}</span>
              </div>
              <i>
                <span>￥{{item.money}}</span>
              </i>
              <b :title="item.desc">{{item.desc}}</b>
            </li>
          </ul>
        </div>
        <div class="content_right">
          <div class="qrcode_box">
            <img v-if="$store.state.webInfo.style=='shaodong'" :src="qrUrl" alt />
            <div v-else id="qrcode" ref="qrcode"></div>
            <div class="text_box">
              <p v-if="$store.state.webInfo.style=='shaodong'">公众号二维码</p>
              <p v-else>捐赠二维码</p>
              <p>技术支持：长沙普益云软件科技有限公司</p>
            </div>
          </div>
          <div class="amount_box">
            <div class="money">
              <div>
                ￥
                <numScroll :value="amount"></numScroll>
                <div class="text">总捐款额</div>
              </div>
            </div>
            <div class="number">
              <div>
                <numScroll :value="number"></numScroll>次
                <div class="text">捐款人次</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numScroll from "./numScroll";
import QRCode from "qrcodejs2";
import { mapActions } from "vuex";
import { wsUrl } from "@/config/index";
export default {
  components: {
    numScroll
  },
  data() {
    return {
      amount: 0,
      peopleData: [],
      animate: true,
      number: 0,
      isscroll: false,
      scrolls: false,
      logoUrl: "",
      ws_amount: 0,
      qrUrl: ""
    };
  },
  created() {
    let that = this;
    this.$db
      .get(this.$url.webconfigInfo)
      .then(resp => {
        if(resp.code ==200 && resp.data){
          this.webconfig = resp.data;
          this.logoUrl = resp.data.logo_text.url; //设置logo
          this.$store.state.webInfo = resp.data;
          this.qrcode();
        }
      })
      .then(() => {
        if(this.$store.state.webInfo && (this.$store.state.webInfo.donation_project_id||this.$store.state.webInfo.donation_project_id==0)){        
          //查询所有捐赠信息
          this.$db
            .get(this.$url.donation.list, {
              id: this.$store.state.webInfo.donation_project_id,
              page_size: 50
            })
            .then(resp => {
              if (resp && resp.data) {
                that.peopleData = resp.data.data;
                if (resp.data.data.length > 7) {
                  that.scrolls = true;
                  setInterval(this.scroll, 3000);
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
          //查询捐赠总人数和总金额
          that.$db
            .get(that.$url.donation.index, {
              id: this.$store.state.webInfo.donation_project_id
            })
            .then(resp => {
              if (resp && resp.data) {
                that.amount = Number(resp.data.donation_sum);
                that.amount = Math.round(that.amount);
                that.number = Number(resp.data.donation_count);
              }
            }).catch(err => {
              console.log(err);
            });
        }
        let ws = new WebSocket(wsUrl);
        ws.onopen = function() {
          ws.send('{"type":"big_screen"}');
        };
        ws.onmessage = function({ data }) {
          data = JSON.parse(data);
          // //根据返回的订单号查询对应的捐赠数据并累加
          let info = {
            pub_name: data.pub_name,
            headimg_url: data.headimg_url,
            money: data.money,
            desc: data.desc
          };
          that.peopleData.unshift(info);
          that.peopleData.pop;
          that.amount += Number(info.money);
          that.amount = Math.round(that.amount);
          that.number++;
          that.isscroll = true;
        };
      })
      .catch(err => {
        console.log(err);
      });
  },
  computed: {
    classOption() {
      return {
        step: 1,
        direction: 0
      };
    }
  },
  methods: {
    ...mapActions(["getWebconfigInfo"]),
    qrcode() {
      if (this.$store.state.webInfo.style == "shaodong") {
        this.qrUrl = this.$store.state.webInfo.wechat_qrcode_text.url;
      } else {
        setTimeout(() => {
          // document.getElementById("qrcode").innerHTML = "";
          new QRCode(this.$refs.qrcode, {
            text:
              this.$store.state.webInfo.donation_url +
              this.$store.state.webInfo.donation_project_id,
            width: 230,
            height: 230,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.L
          });
        }, 100);
      }
    },
    scroll() {
      let con1 = this.$refs.rollul;
      con1[0].style.marginTop = "-6.9vh";
      this.animate = !this.animate;
      var that = this;
      var num = that.peopleData.length;
      setTimeout(function() {
        that.peopleData.unshift(that.peopleData[num - 1]);
        that.peopleData.pop();
        con1[0].style.marginTop = "0";
        that.animate = !that.animate;
      }, 0);
    }
  },
  watch: {
    isscroll(newVal) {
      if (this.peopleData.length && !this.scrolls) {
        setInterval(this.scroll, 3000);
      }
    }
  }
};
</script>

<style lang="less" scoped>
#app-index {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/images/donate_bg2.png") no-repeat;
}
.index-box {
  width: 100%;
  position: relative;
  overflow: hidden;
  .logo {
    position: absolute;
    top: 17vh;
    left: 0;
    width: 40vw;
    text-align: center;
    > img {
      height: 9.2vh;
    }
  }
  .content {
    width: 88vw;
    height: 66vh;
    border-radius: 2px;
    background-color: #fff;
    margin: 30vh 6vw 0;
    overflow: hidden;
    display: flex;
    opacity: 0.9;
    .scroll_box {
      width: 50%;
      height: 55vh;
      overflow: hidden;
      transition: all 0.5s;
      margin: 5vh 0 0 1.6vw;
      background-color: #fff;
      ul {
        overflow: hidden;
        margin: 0;
        padding-left: 0;
        > li {
          list-style: none;
          // width: 95%;
          height: 6vh;
          display: flex;
          background-size: 100% 100%;
          padding-right: 5%;
          overflow: hidden;
          background-color: #fffaf9;
          border-radius: 34px;
          margin-bottom: 0.7vh;
          .p-box {
            display: flex;
            width: 26%;
            margin-left: 1vw;
            > img {
              width: 2vw;
              height: 3.7vh;
              margin-top: 1.1vh;
              border-radius: 50%;
            }
            span {
              font-size: 1vw;
              color: #593b3b;
              line-height: 6vh;
              margin-left: 0.8vw;
              overflow: hidden;
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分省略号显示*/
            }
          }

          > i {
            width: 30%;
            font-size: 1.4vw;
            font-weight: 600;
            color: #593b3b;
            font-style: normal;
            position: relative;
            > span {
              display: block;
              width: 7.9vw;
              height: 3vh;
              border-radius: 32px;
              line-height: 3vh;
              text-align: center;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              color: #593b3b;
              border: 1px dashed #505050;
              font-size: 1vw;
              color: red;
            }
          }
          > b {
            width: 40%;
            font-size: 1vw;
            font-weight: normal;
            color: #593b3b;
            float: right;
            line-height: 6vh;
            overflow: hidden;
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
        }
      }
    }
    .content_right {
      width: 50%;
      .amount_box {
        display: flex;
        margin-left: 2vw;
        > div {
          width: 16vw;
          height: 16vw;
          background: url("../../assets/images/amuont_bg.png") no-repeat;
          margin: 4vh 4vw 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #e83c3c;
          background-size: 100% 100%;
          > div {
            > div {
              font-size: 1vw;
              text-align: center;
            }
          }
        }
      }
      .qrcode_box {
        display: flex;
        align-items: center;
        padding-right: 4.6vw;
        margin-top: 4vh;
        margin-left: 1vw;
        > img {
          width: 12vw;
          height: 12vw;
          margin-left: 3vw;
          margin-right: 5vw;
        }
        .text_box {
          color: #593b3b;
          font-size: 0.9vw;
          :first-child {
            font-size: 1.3vw;
          }
        }
        #qrcode {
          margin-left: 3vw;
          margin-right: 5vw;
        }
      }
    }
  }
}

.scroll_box /deep/ .el-button {
  font-size: 1vw;
  color: #593b3b;
  background-color: none;
  border: none;
  padding: 3% 6%;
  border: none;
}

.amount_box div div /deep/ .number-grow-warp span {
  color: #e83c3c;
  font-size: 26px;
  font-weight: 700;
}

.anim {
  transition: all 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/copy.vue